<template>
    <div class="code-mgt ">
        <el-card class="table_searchbar">
            <el-row :gutter="20" style="margin-bottom: 20px;">
                <el-col :span="5">
                    <div class="" >
                        <span class="title">一级菜单：</span>
                        
                        <el-select style="max-width:200px" v-model="value1" placeholder="请选择" @change="getSecondtMenu()">
                            <el-option v-for="item in options1" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="" >
                        <span class="title">二级菜单：</span>
                        
                        <el-select style="max-width:200px" v-model="value2" :disabled='value1 ? false : true' placeholder="请选择" @change="getSecondtMenu()">
                            <el-option v-for="item in options2" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </div>
                </el-col>
        
                <el-col :span="14" >
                    <div style="text-align:right">
                        <el-button type="primary" @click="search">查询</el-button>
                        <el-button @click="reset">重置</el-button>
                    </div>
                </el-col>
            </el-row>
        </el-card>
        <el-card class="table-card">
            <div class="container">
                <el-table
                    :data="tableData"
                    style="width: 100%">
                    <el-table-column prop="firstMenu" label="一级菜单"> </el-table-column>
                    <el-table-column prop="secondMenu" label="二级菜单"> </el-table-column>
                    <el-table-column prop="encodeName" label="编码名称"> </el-table-column>
                    <el-table-column label="操作" v-if="permission.btn_encode_update">
                        <template slot-scope="scope">
                            <i class="el-icon-edit-outline" @click="handleClick(scope.row.id)" style="color:#409EFF;fontSize:20px"></i>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
          
            <div class="page" v-if="tableData.length>0" :style="{marginBottom:'20px'}">
                <div class="total_page"><span> 共{{total}}条 10条/页</span></div>
                <div style="margin-top:10px;text-align:right; margin-bottom:20px;">
                    <el-pagination background layout="prev, pager, next" :total="total" @current-change="pageChange" :current-page="pageNum"></el-pagination>
                </div>
            </div>
            
        </el-card>
        
        <!-- 编辑弹窗开始 -->
        <el-dialog title="编辑" 
        :visible.sync="dialogFormVisible" 
        @close="dialogFormVisible = false" width="38%"
        :close-on-click-modal="false">
            <el-form ref="form" label-width="150px">
                <el-form-item :label="currentCodeName">
                    <el-input v-model="code" :disabled="true" style="width:300px"></el-input>
                </el-form-item>
            </el-form>
                <div class="cut-off-line"></div>
                <el-row style="text-align:center">
                    <!-- <el-col :span="3">
                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"></el-checkbox>
                    </el-col> -->
                    <el-col :span="8">规则</el-col>
                    <el-col :span="10">内容 </el-col>
                    <el-col :span="6">操作</el-col>
                </el-row>
                <div style="margin: 15px 0;"></div>
                    <el-form>
                        <el-row style="text-align:center" v-for="(item,i) in tableRules" :key="item.id">
                            <!-- <el-col :span="3">
                                <el-checkbox v-model="item.ischecked"  @change="handleCheckedRulesChange" :disabled="item.id == '1' || item.id == '2'"></el-checkbox>
                            </el-col> -->
                            <el-col :span="8">
                                <div class="rule-name">{{item.name}}</div> 
                            </el-col>
                            <el-col :span="10">
                                <el-form-item v-if="item.name == '自定义'">
                                    <el-input oninput="value=value.replace(/[\W]/g,'');" @blur="item.value = $event.target.value" v-model="item.value" maxlength="8" style="width:140px"></el-input>
                                </el-form-item>
                                <el-form-item v-else-if="item.name == '日期' || item.name== '时间'">
                                    <el-input v-model="item.value" :disabled="true" style="width:140px"></el-input>
                                </el-form-item>
                                <el-form-item v-else>
                                    <el-select v-model="item.value" placeholder="请选择" style="width:140px">
                                        <el-option
                                            v-for="item1 in numOptions"
                                            :key="item1"
                                            :label="item1"
                                            :value="item1">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item v-show="item.name == '序号'" style="margin-bottom: 0 !important;">
                                    <div class="restoration">
                                        <el-checkbox v-model="isRestoration"></el-checkbox>按日复位
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <img v-if="i == 0" style="height:32px;" src="static\img\notup.png" alt="" >
                                <img v-else  @click="moveup(i)" style="height:32px;" src="static\img\up.png" alt="" >
                                <img v-if="i == 3" style="height:32px;" src="static\img\notdown.png" alt="">
                                <img v-else @click="movedown(i)" style="height:32px;" src="static\img\down.png" alt="">
                            </el-col>
                        </el-row>     
                    </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 编辑弹窗结束 -->
    </div>
</template>
<script>
export default {
    data(){
        return{
            value1:'',// 一级菜单
            value2:'',// 二级菜单
            // 一级菜单选项
            options1:[],
            // 二级菜单选项
            options2:[],
            // 数据信息
            tableData:[],
            total:0, //数据总数
            pageNum: 1, //当前页码
            dialogFormVisible: false,// 编辑弹窗是否展示
            currentCodeName:'', // 当前编码名称
            code:'', //编码
            // checkAll: true, // 全选
            // isIndeterminate: true,
            // 序号选项
            numOptions:['3位','4位','5位',],
            tableRules:[],
            updateId:'',
            isRestoration:0,
            permission:JSON.parse(localStorage.getItem("permission"))
        }
    },
    watch:{
        // 当规则信息修改时，编码修改
        tableRules:{
            handler(newval,oldval){
                this.createCode()
            },
            deep: true
        },
    },
    mounted(){
        this.search();
        this.getFirstMenu();
    },
    methods:{
        // 获取一级菜单列表
        getFirstMenu(){
            this.$RequestUtil.get({
                url: '/api/encode/first-menu-down-list',
                params: {},
                success: (res) => {
                    if (res.code == 0) {
                        this.options1 = res.data
                    }
                }
            });
        },
        // 获取二级级菜单列表
        getSecondtMenu(){
            this.value2 = '';
            this.$RequestUtil.get({
                url: '/api/encode/second-menu-down-list',
                params: { firstMenu: this.value1 },
                success: (res) => {
                    if (res.code == 0) {
                        this.options2 = res.data
                    }
                }
            });
        },
        // 搜索
        search(){
            this.$RequestUtil.post({
                url: '/api/encode/get-list',
                params: {
                    firstMenu:this.value1,
                    secondMenu:this.value2,
                    pageNum:this.value1? 1 : this.pageNum,
                    pageSize:10
                },
                success: (res) => {
                    if (res.code == 0) {
                        this.tableData = res.data.list
                        this.total = res.data.total
                        this.pageNum = res.data.pageNum
                    }
                }
            });
        },
        // 页码改变
        pageChange(targetPage){
            this.pageNum = targetPage;
            this.value1 = '',
            this.value2 = '',
            this.search()
        },
        // 重置
        reset(){
            this.value1 = '';
            this.value2 = '';
        },
        // 编辑
        handleClick(id){
            this.$RequestUtil.get({
                url: '/api/encode/get-encode-style',
                params: {
                    id
                },
                success: (res) => {
                    if (res.code == 0) {
                        this.tableRules = res.data.encodeStyleVOList
                        this.currentCodeName = res.data.encodeName
                        this.code = res.data.code
                        this.isRestoration = res.data.isRestoration == 1 ? true : false;
                        this.updateId = res.data.id;
                    }
                }
            });
            this.dialogFormVisible = true;
        },
        // 生成code
        createCode(){
            let date,time,numValue;
            let code = ['','','','']
             for(let item in this.tableRules){
                if(this.tableRules[item].name == '自定义'){  // 自定义
                    code[item] = this.tableRules[item].value;
                }else if(this.tableRules[item].name == '日期'){ //日期
                    date = new Date()
                    let y = date.getFullYear();
                    let m = date.getMonth() + 1;
                    let d = date.getDate();
                    code[item] = y + ( m > 9 ? m : ('0' + m) ) + ( d > 9 ? d : ('0' + d) )
                }else if(this.tableRules[item].name == '时间'){  //时间
                    time = new Date()
                    let hh = time.getHours();
                    let mm = time.getMinutes();
                    let ss = time.getSeconds();
                    code[item] =  String(hh > 9 ? hh : ('0' + hh)) + String(mm > 9 ? mm : ('0' + mm))  + String(ss > 9 ? ss : ('0' + ss) )
                }else{   // 序号
                    numValue = this.tableRules[item].value
                    code[item] = numValue == '3位' ? '001' : numValue == '4位' ? '0001' : '00001'
                }
             }
            this.code = code[0] + code[1] + code[2] + code[3]
        },
        // 确定编辑
        confirm(){
            this.$RequestUtil.post({
                url: '/api/encode/update',
                params: {
                    id: this.updateId,
                    isRestoration: this.isRestoration == true ? 1 : 0,
                    encodeStyleVOS: this.tableRules,
                },
                success: (res) => {
                    if (res.code == 0) {
                        this.$message.success('修改成功')
                        this.search()
                    }else{
                        this.$message.error('修改失败')
                    }
                    this.dialogFormVisible = false;
                }
            });
        },
        // 取消编辑
        cancel(){
            this.dialogFormVisible = false;
            this.code = ''
            this.tableRules = []
        },
        // 上移
        moveup(i){
            // 交换前后两个元素的值
            let obj = this.tableRules[i];
            this.tableRules.splice( i,1,this.tableRules[i - 1] )
            this.tableRules.splice( i - 1,1,obj )
        },
        // 下移
        movedown(i){
            let obj = this.tableRules[i];
            this.tableRules.splice( i,1,this.tableRules[i + 1] )
            this.tableRules.splice( i + 1,1,obj )
        }
    }
}
</script>
<style scoped>
    .container{
        margin-top: 20px;
    }
    .block{
        margin-top: 20px;
        margin-right: 20px;
        float: right;
    }
    .cut-off-line{
        width: 100%;
        border-top: 1px solid #DCDFE6;
        height: 20px;
        margin-top: 20px;
    }
    .rule-name{
        height:32px;
        line-height:32px;
        width:110px;
        border:1px solid #DCDFE6;
        border-radius: 4px;
        margin: 0 auto;
        box-sizing: border-box;
    }
    .restoration{
        font-size: 14px;
        width:70px;
        position: absolute;
        right: -38px;
        bottom: 15px;
    }
    .page {
        display: flex;
        justify-content: flex-end;
    }
    .total_page {
        margin-top: 8px;
        margin-right: 26px;
        color: #606266;
        font-size: 14px;
    }
</style>


// WEBPACK FOOTER //
// src/views/masterdata/CodeMgt.vue